const FlashQuery = () => import("@/views/flash-config/FlashQuery");
const FlashQueryList = () => import("@/views/flash-config/FlashQueryList");
const FlashTips = () => import("@/views/flash-config/FlashTips");

const configRoutes = [
    {
        path: "/flashQuery",
        name: "FlashQuery",
        meta: {
            title: "titles.flashQuery"
        },
        component: FlashQuery
    },
    {
        path: "/flashQueryList",
        name: "FlashQueryList",
        meta: {
            title: "闪光配置查询"
        },
        component: FlashQueryList
    },
    {
        path: "/flashTips",
        name: "FlashTips",
        meta: {
            title: "闪光调试攻略"
        },
        component: FlashTips
    },
];
export default configRoutes;
